// Get currentUser info from client local storage
export const loadCurrentUser = () => {
  try {
    let userString = localStorage.getItem('currentUser');
    return JSON.parse(userString);
  } catch {
    return {};
  }
};

// Store currentUser info to client local storage
export const storeCurrentUser = (userData) => {
  localStorage.setItem('currentUser', JSON.stringify(userData));
};
